module.exports = __webpack_public_path__ + "static/media/wave.f62fce1a.svg";